import { Pipe, PipeTransform } from '@angular/core';
import { sameDay, yestrday, dateFormatIS } from '../utils/date.utils';

@Pipe({ name: 'MaxAccountDate' })
export class MaxAccountDatePipe implements PipeTransform {
    transform(value: string | number, valueAsNumber?: boolean): string {
        if (valueAsNumber) {
            value = +value;
        }

        const date: Date = new Date(value);
        const currDate = new Date();

        if (value === undefined) {
            return '';
        }
        if (sameDay(currDate, date)) {
            return 'היום';
        } else if (yestrday(date, currDate)) {
            return 'אתמול';
        }
        return dateFormatIS(date);
    }
}
